import React, { useState } from 'react';
import { Box, Flex } from 'theme-ui';
import { navigate } from 'gatsby';
import ContentText from '@solid-ui-components/ContentText';
import ContentImages from '@solid-ui-components/ContentImages';
import LongArrowIcon from '@solid-ui-components/Icons/LongArrowIcon';
import palette from '@solid-ui-theme/palette';
import ArrowIcon from '@solid-ui-components/Icons/ArrowIcon';
import { styles } from './style';

const { fullButton, arrowWrapper, arrow } = styles;

const formLink = (text) => text?.toLowerCase();

const FullButton = ({ content: { collection } }) => {
  const [isFullBtnHovered, setIsFullBtnHovered] = useState(false);

  return (
    <Flex
      sx={fullButton}
      onClick={() =>
        navigate(`/${formLink(collection[0]?.text?.[0].text)}` ?? '/')
      }
      onMouseOver={() => setIsFullBtnHovered(true)}
      onMouseOut={() => setIsFullBtnHovered(false)}
    >
      <ContentText content={collection?.[0].text.slice(1, 2)} />
      <ContentImages
        content={collection?.[0]}
        loading='eager'
        imagePosition='center'
      />
      <ContentText content={collection?.[0].text.slice(2)} />
      <Box sx={arrowWrapper}>
        {isFullBtnHovered ? (
          <LongArrowIcon color={palette.gray900} />
        ) : (
          <ArrowIcon style={arrow} color={palette.gray900} />
        )}
      </Box>
    </Flex>
  );
};

export default FullButton;
